import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import { ModalFooter } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2, Label } from 'components/common/form-controls';
import { FileDropZone } from 'components/common/media';

import { SUBSCRIPTION_DOCUMENT_TYPES, ACCEPT_DOCUMENTS } from './constants';
import validationSchema from './validationSchema';

import styles from './uploadSubscriptionDocument.style';

const UploadSubscriptionDocumentForm = ({
  defaultValues = {},
  isLoading,
  onCancel,
  onSubmit,
}) => {
  const [documents, setDocuments] = useState([]);
  const resolver = yupResolver(validationSchema);

  const methods = useForm({ defaultValues, resolver });

  const handleDocuments = (files) => {
    setDocuments([...files]);
  };

  const handleSubmit = (values) => {
    onSubmit({ ...values, documents });
  };

  const isDisabledSubmit =
    isLoading || methods.formState.isSubmitting || documents.length === 0;

  return (
    <FormProvider {...methods}>
      <form
        id="add-upload-subscription-document-form"
        onSubmit={methods.handleSubmit(handleSubmit)}
      >
        <FieldV2
          isRequired
          label="Document Type"
          type="dropdown"
          control={methods.control}
          name="type"
          options={SUBSCRIPTION_DOCUMENT_TYPES}
        />
        <FieldV2
          label="Λήξη Αρχείου"
          type="date"
          control={methods.control}
          name="expire"
        />
        <Box sx={styles.fileDropZoneContainer}>
          <Label isRequired>Επιλογή Αρχείου</Label>
          <FileDropZone
            showHeader={false}
            multiple={false}
            previewFiles={false}
            callBack={handleDocuments}
            currentFiles={documents}
            accept={ACCEPT_DOCUMENTS}
            styles={styles}
          />
        </Box>
        <ModalFooter>
          <ButtonV2 type="button" variant="outlined" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2
            form="add-upload-subscription-document-form"
            type="submit"
            loading={isLoading}
            disabled={isDisabledSubmit}
          >
            Save
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default UploadSubscriptionDocumentForm;
